import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Minimize } from 'lucide-react';
import { Button } from '../components/ui/button';
import './AirplaneQuizGame.css';

const AirplaneQuizGame = () => {
  const navigate = useNavigate();
  const iframeRef = useRef(null);
  const containerRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    // Auto-enter fullscreen when component mounts
    const enterFullscreen = async () => {
      try {
        if (containerRef.current) {
          if (containerRef.current.requestFullscreen) {
            await containerRef.current.requestFullscreen();
          } else if (containerRef.current.webkitRequestFullscreen) {
            await containerRef.current.webkitRequestFullscreen();
          } else if (containerRef.current.mozRequestFullScreen) {
            await containerRef.current.mozRequestFullScreen();
          } else if (containerRef.current.msRequestFullscreen) {
            await containerRef.current.msRequestFullscreen();
          }
          setIsFullscreen(true);
        }
      } catch (err) {
        console.log('Fullscreen request failed:', err);
      }
    };

    // Delay to ensure component is mounted
    const timer = setTimeout(enterFullscreen, 500);

    // Listen for fullscreen changes
    const handleFullscreenChange = () => {
      const isCurrentlyFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );
      setIsFullscreen(isCurrentlyFullscreen);
      
      // If user exits fullscreen, navigate back to dashboard
      if (!isCurrentlyFullscreen) {
        navigate('/dashboard');
      }
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, [navigate]);

  const exitFullscreen = async () => {
    try {
      if (document.exitFullscreen) {
        await document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        await document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        await document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        await document.msExitFullscreen();
      }
      navigate('/dashboard');
    } catch (err) {
      console.log('Exit fullscreen failed:', err);
      navigate('/dashboard');
    }
  };

  return (
    <div ref={containerRef} className="airplane-quiz-game-page">
      {isFullscreen && (
        <div className="exit-button-container">
          <Button onClick={exitFullscreen} className="exit-btn" variant="ghost">
            <Minimize size={20} />
            Exit Game
          </Button>
        </div>
      )}
      {!isFullscreen && (
        <div className="airplane-game-header">
          <Button onClick={() => navigate('/dashboard')} className="back-btn" variant="ghost">
            <ArrowLeft size={20} />
            Back to Dashboard
          </Button>
        </div>
      )}
      <iframe
        ref={iframeRef}
        src="/airplane-quiz.html"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        }}
        title="Airplane Quiz Game"
        allow="fullscreen"
      />
    </div>
  );
};

export default AirplaneQuizGame;
